import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  max-height: 80vh;
  overflow-y: scroll;
  padding: 5rem 7rem;
  scrollbar-width: none;
  width: 70rem;

  -ms-overflow-style: none;
  ::-webkit-scrollbar {
    display: none;
  }

  h1 {
    ${(props) => `
      color: ${props.theme.colors.blackTextBody};
    `}
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 3rem;
  }

  .input-label {
    align-self: start;
    color: ${(props) =>
      props.theme.colors.blackTextBody + props.theme.transparencies.p30};
    display: flex;
    font-size: 1.4rem;
    font-weight: 500;
    margin-top: 1.5rem;
    padding: 1rem 0.5rem;
  }

  .warning-message {
    ${(props) => `
      background-color: ${
        props.theme.colors.supportYellow + props.theme.transparencies.p20
      };
      color: ${props.theme.colors.blackTextBody};
    `}

    border-radius: 10px;
    display: flex;
    gap: 1rem;
    margin-top: 1.5rem;
    padding: 0 1rem;
    width: 100%;

    & > p {
      font-size: 1.4rem;
    }
  }
`;

interface IButtons {
  changeRuc?: any;
}
export const Buttons = styled.div<IButtons>`
  display: flex;
  justify-content: ${(props) => (props.changeRuc ? "space-between" : "center")};
  width: 100%;
`;

interface IMainButton {
  changeRuc?: any;
  center?: any;
}
export const MainButton = styled.button<IMainButton>`
  ${(props) => `
    background-color: ${
      props.changeRuc
        ? props.theme.colors.white
        : props.theme.colors.accentGreen
    };
    color: ${
      props.changeRuc
        ? props.theme.colors.accentGreen
        : props.theme.colors.white
    };
    font-family: ${props.theme.fontFamilies.primaryFont};
    border: ${
      props.changeRuc ? `1px solid ${props.theme.colors.accentGreen}` : "none"
    };
  `}

  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  font-size: 1.5rem;
  font-weight: 700;
  justify-content: center;
  margin-top: 4rem;
  min-height: 5.8rem;
  width: 25rem;

  &:disabled,
  &[disabled] {
    background-color: ${(props) =>
      props.theme.colors.accentGreen + props.theme.transparencies.p20};
    cursor: not-allowed;
  }

  img {
    height: 5rem;
    width: 5rem;
  }
`;
